import { useMemo } from 'react';
import { useIsFeatureEnabled } from '@shared/core/featureFlags';
import { useEventFeatureFlags } from '@shared/hooks/useEventFeatureFlags/useEventFeatureFlags';
import { useEventInfo } from '@shared/utils/eventInfo';

type UseWebsiteDesignerV3FeatureReturnType = Readonly<{
  value: boolean;
  isLoading: boolean;
}>;

export const useWebsiteDesignerV3Feature = (): UseWebsiteDesignerV3FeatureReturnType => {
  const { eventHandle } = useEventInfo();

  const eventFeatureFlags = useEventFeatureFlags({ eventHandle: eventHandle || '', skip: !eventHandle });
  const isEventEligible = !eventFeatureFlags.loadingEventFeatureFlags && eventFeatureFlags.isEventFeatureFlagEnabled('useWebsiteDesignerV3');

  const [isEnabled, isLoading] = useIsFeatureEnabled('websiteDesignerV3Enabled', {
    skip: !isEventEligible,
  });

  return useMemo(
    () => ({
      value: isEnabled,
      isLoading,
    }),
    [isEnabled, isLoading],
  );
};
